<template>
  <b-modal ref="modal" class="text-left" @ok="createVector" @cancel="clearVector">
    <alert ref="alert" />
    <div slot="modal-title">New vector</div>
    <b-row class="mb-2">
      <b-col class="text-center">
        <b-btn variant="info" @click="vectorType = 1">Empty</b-btn>
        <b-btn variant="info" @click="vectorType = 2">From ranges</b-btn>
        <label class="file-select">
          <div class="btn btn-info" @click="vectorType = 3">
            <span>Load from XLSX</span>
          </div>
          <b-form-file class="mt-3" id="xlsx_select" @change="handleFileChange" plain></b-form-file>
        </label>
      </b-col>
    </b-row>
    <b-row v-if="vectorType == 1 || vectorType == 2">
      <b-col>
        <b-form-group label="Vector name:" label-for="vectorName">
          <b-form-input id="vectorName" type="text" v-model="vectorName" required placeholder="Vector name">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="vectorType == 2">
      <b-col>
        <table class="table table-sm color mb-2">
          <thead>
            <th class="text-left text-nowrap">Start period</th>
            <th class="text-left text-nowrap">End period</th>
            <th class="text-left text-nowrap">Start value</th>
            <th class="text-left text-nowrap">End value</th>
          </thead>
          <tbody>
            <vector-range :range="range" v-for="range in ranges" :key="range.startPeriod" @rangeChange="onRangeChange" />
          </tbody>
        </table>
        <b-btn v-if="ranges.length > 1" variant="danger" size="sm" @click="removeRange">Remove last range</b-btn>
        <b-btn variant="info" size="sm" @click="addRange">Add range</b-btn>
      </b-col>
    </b-row>
    <b-row v-if="$store.getters.isAdmin">
      <b-col>
        <b-form-checkbox v-model="shared" class="mt-2">
          Shared
        </b-form-checkbox>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { isNumericArrayValid } from '../../utilities/ArrayUtils';
import formatter from '../../utilities/Formatter';
import Alert from '../Alert';
import VectorRange from './VectorRange';

export default {
  data() {
    return {
      vectorName: '',
      shared: false,
      vectorValue: [],
      ranges: [{ id: 0, startPeriod: 1, endPeriod: 2, startValue: 0, endValue: 0 }],
      vectorType: 0,
      alert: {
        timestamp: 0,
        type: '',
        msg: ''
      }
    };
  },
  methods: {
    onRangeChange(changedRange) {
      let id = changedRange.id;
      if (id != this.ranges.length - 1) {
        this.ranges[id + 1].startPeriod = Number(changedRange.endPeriod);
        this.ranges[id + 1].startValue = Number(changedRange.endValue);
      }
    },
    addRange() {
      let lastRow = this.ranges[this.ranges.length - 1];
      this.ranges.push({
        id: this.ranges.length,
        startPeriod: lastRow.endPeriod,
        endPeriod: Number(lastRow.endPeriod) + 1,
        startValue: lastRow.endValue,
        endValue: 0
      });
    },
    removeRange() {
      this.ranges.pop();
    },
    createVector(evt) {
      if (this.vectorName == '') {
        evt.preventDefault();
        this.$refs.alert.showAlert('danger', 'Vector name cannot be empty.');
      } else {
        let valid = true;
        if (this.vectorType == 2) {
          try {
            this.vectorValue = generateVectorValue(this.ranges);
          } catch (err) {
            evt.preventDefault();
            valid = false;
            this.$refs.alert.showAlert('danger', err.message);
          }
        } else if (this.vectorType == 3) {
          let parsedVector = this.vectorValue
            .split(/\s+/)
            .map(s => s.split('%')[0])
            .map(x => +x);
          if (!isNumericArrayValid(parsedVector)) {
            evt.preventDefault();
            valid = false;
            this.$refs.alert.showAlert('danger', 'Failed to parse the pasted value.');
          } else {
            this.vectorValue = parsedVector;
          }
        }
        if (valid) {
          this.$emit('vectorCreated', {
            Name: this.vectorName,
            Value: this.vectorValue,
            Shared: this.shared
          });
          this.clearVector();
        }
      }
    },
    clearVector() {
      this.vectorName = '';
      this.vectorValue = [];
      this.ranges = [
        {
          id: 0,
          startPeriod: 1,
          endPeriod: 2,
          startValue: 0,
          endValue: 0
        }
      ];
      this.vectorType = 0;
      this.$refs.modal.hide();
    },
    showModal() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    handleFileChange(e) {
      let file = e.target.files[0];
      this.$emit('loadVectors', file);
    }
  },
  components: {
    Alert,
    VectorRange
  }
};
function validatePeriods(startPeriod, endPeriod) {
  let errorMsg;
  if (startPeriod < 1) {
    errorMsg = 'Start period cannot be smaller than 1';
  } else if (endPeriod <= startPeriod) {
    errorMsg = 'End period must be bigger than start period';
  }
  return errorMsg;
}
function generateVectorValue(ranges) {
  let out = [0];
  for (let index = 0; index < ranges.length; index++) {
    let row = ranges[index];
    let startPeriod = parseFloat(row.startPeriod);
    let endPeriod = parseFloat(row.endPeriod);
    let startValue = parseFloat(row.startValue);
    let endValue = parseFloat(row.endValue);

    if ((index == 0) & (startPeriod != 1)) {
      for (let t = 0; t < startPeriod - 1; t++) {
        out.push(0);
      }
    }

    let errorMsg = validatePeriods(startPeriod, endPeriod);
    if (errorMsg) {
      throw new RangeError(errorMsg);
    }

    let gradientVal =
      endValue == startValue ? 0 : (endValue - startValue) / (endPeriod - startPeriod);

    for (let i = startPeriod; i < endPeriod; i++) {
      if (i == startPeriod) {
        out.push(startValue);
      } else {
        let val = parseFloat(formatter.round(out[i - 1] + gradientVal));
        out.push(val);
      }
    }
    if (index == ranges.length - 1) {
      out.push(parseFloat(formatter.round(out[out.length - 1] + gradientVal)));
    }
  }
  out.shift();
  return out;
}
</script>

<style lang="scss" scoped>
.fixed {
  padding: 0.6rem 0.3rem 0.3rem 1rem;
}

#xlsx_select {
  display: none;
}
</style>
